


























































































import {
  ref,
  defineComponent,
  computed,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import { useDeps } from '~/compositions/dependency-container'
import { useNamespacedStore } from '~/compositions/store'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import RouteGuardService from '~/services/RouteGuardService'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import {
  ADMINUSER_NS,
  AdminUserState
} from '~/store/modules/shared/admin/user/state'
import { ciUserCircle as ciUserCircleRegular } from '~/icons/source/regular/user-circle'
import { ciUserCircle as ciUserCircleSolid } from '~/icons/source/solid/user-circle'
import { ciMyClassifieds } from '~/icons/source/regular/my-classifieds'
import { ciParking } from '~/icons/source/regular/parking'
import { ciParkingP } from '~/icons/source/solid/parking-p'
import { ciHamburger } from '~/icons/source/regular/hamburger'
import { ciArrowAltLeft } from '~/icons/source/solid/arrow-alt-left'
import HeaderLogo from '~/components/car/header/HeaderLogo.vue'
import HeaderNavigationMenu from '~/components/car/header/HeaderNavigationMenu.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import HeaderParking from '~/components/car/header/HeaderParking.vue'
import HeaderCart from '~/components/car/header/HeaderCart.vue'
import HeaderLanguage from '~/components/car/header/HeaderLanguage.vue'
import { useGlobalElements } from '~/compositions/global-elements'

// NOTE: base api here -> https://www.car.gr/api/user/base-page/ user_base_page
// TODOs:
// - Parking and message notifications test with mock data

export default defineComponent({
  components: {
    HeaderLogo,
    HeaderNavigationMenu,
    HeaderParking,
    HeaderCart,
    HeaderLanguage,
    CLink,
    CIcon,
    HeaderAdminTopBar: defineVue3AsyncComponent(() =>
      import('~/components/car/header/HeaderAdminTopBar.vue')
    ),
    HeaderMobileMenu: defineVue3AsyncComponent(() =>
      import('~/components/car/header/HeaderMobileMenu.vue')
    ),
    HeaderUser: defineVue3AsyncComponent(() =>
      import('~/components/car/header/HeaderUser.vue')
    ),
    CExternalLinkMediatorModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
      )
    )
  },
  props: {
    availableLocales: {
      type: Array,
      required: true
    }
  },
  setup() {
    const [legacyUrlService, routeGuardService] = useDeps(
      LegacyUrlService,
      RouteGuardService
    )
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const { state: adminUserState } = useNamespacedStore<AdminUserState>(
      ADMINUSER_NS
    )

    const { showMobileBottomMenu } = useGlobalElements()

    const showMobileMenu = ref(false)
    const showExternalLinkMediatorModal = ref(false)
    const externalLinkMediatorUrl = ref('')
    const mobileMenuRef = ref(null)

    const isAdmin = computed(() => userGetters('isAdmin'))
    const isAnon = computed(() => userGetters('isSingleOrAnon'))

    const adminExtras = computed(() => adminUserState.adminExtras)
    const hasAccessToParking = routeGuardService.userHasAccessToParking()
    const offerBtnLink = legacyUrlService.offerBtnLink()
    const offerBtnText = legacyUrlService.offerBtnText()
    const offerBtnIcon = legacyUrlService.offerBtnIcon()
    const offerBtnIconSolid = legacyUrlService.offerBtnIconSolid()

    const cartItemsCount = computed(() =>
      userGetters('marketplaceCartItemsCount')
    )
    const showCartButton = computed(() => cartItemsCount.value > 0)

    function triggerMenuClose() {
      if (mobileMenuRef.value) {
        mobileMenuRef.value.closeMenu()
      }
    }
    return {
      ciUserCircleRegular,
      ciUserCircleSolid,
      ciMyClassifieds,
      ciParking,
      ciParkingP,
      ciHamburger,
      ciArrowAltLeft,
      showMobileMenu,
      mobileMenuRef,
      triggerMenuClose,
      showMobileBottomMenu,
      showExternalLinkMediatorModal,
      externalLinkMediatorUrl,
      offerBtnLink,
      offerBtnText,
      offerBtnIcon,
      hasAccessToParking,
      isAdmin,
      isAnon,
      adminExtras,
      showCartButton,
      offerBtnIconSolid
    }
  }
})
